import React, { Fragment, useEffect } from "react";
import { Route, Switch } from "react-router";

import { CatalogPage } from "./catalog_page";
import { OfferingPage } from "./offering";
import { OfferingCheckoutPage } from "./offering_checkout";
import { OfferingConfirmOrderPage } from "./offering_confirm_order";
import { OfferingGallerySpaceDetailsPage } from "./offering_gallery_space_details";
import { AppTracker } from "../core/app_tracker";
import { CatalogCategoryPage } from "../offering_v2/pages/catalog_category_page";
import { useAnalytics } from "@/lib/analytics/analytics";

export default function OfferingsPageWrapper() {
  const analytics = useAnalytics();

  useEffect(() => {
    const email =
      new URLSearchParams(window.location.search).get("email") || undefined;
    analytics.register({ Source: "WL" });
    if (email) {
      analytics.identify("", { email });
    }
  }, [analytics]);

  return (
    <Fragment>
      <Switch>
        <Route path="/offerings/:offeringID/spaces/:spaceID/checkout">
          <OfferingCheckoutPage />
        </Route>
        <Route path="/offerings/:offeringID/spaces/:spaceID">
          <OfferingGallerySpaceDetailsPage />
        </Route>
        <Route path="/offerings/confirm_order/:offeringID/:orderID">
          <OfferingConfirmOrderPage />
        </Route>
        <Route path="/offerings/checkout/:offeringID">
          <OfferingCheckoutPage />
        </Route>
        <Route path="/offerings/catalog/:partnerSlug/:catalogSlug?">
          <CatalogPage />
        </Route>
        <Route path="/offerings/category/:categorySlug">
          <CatalogCategoryPage />
        </Route>
        <Route path="/offerings/:offeringID">
          <OfferingPage />
        </Route>
      </Switch>
      <AppTracker />
    </Fragment>
  );
}
